import React from 'react';
import { siteData } from '../data/mock';

const Navbar = () => {
  const scrollToWaitlist = () => {
    const lastPageSection = document.querySelector('[data-section="last-page"]');
    if (lastPageSection) {
      lastPageSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: '#fff',
        zIndex: 1000,
        borderBottom: '1px solid #c0c5ce',
      }}
    >
      <div
        className="flex items-center justify-between"
        style={{
          maxWidth: '1212px',
          margin: '0 auto',
          padding: 'clamp(14px, 3vw, 24px) 20px',
        }}
      >
        <span
          style={{
            fontFamily: 'Coolvetica, sans-serif',
            fontSize: 'clamp(22px, 4.2vw, 28px)',
            color: '#000',
            letterSpacing: '-0.02em',
            fontWeight: 400,
          }}
        >
          {siteData.brand.name}
        </span>
        <button
          onClick={scrollToWaitlist}
          className="nav-btn-macos"
          style={{
            fontFamily: 'InterVariable, sans-serif',
            fontSize: 'clamp(14px, 2.6vw, 16px)',
            fontStyle: 'italic',
            fontWeight: 400,
            color: '#000',
            background: 'transparent',
            border: '1px solid #c0c5ce',
            borderRadius: '24px',
            padding: '8px clamp(14px, 4.2vw, 24px)',
            cursor: 'pointer',
            letterSpacing: '-0.025em',
          }}
        >
          {siteData.brand.navCTA}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
